import { toJpeg } from "html-to-image";
import { OS, getUserOS } from "../../../utils/getUserDeviceInfo";

const createImageFromMap = ({ map, mapRef }) => {
  return new Promise((res, rej) => {
    if (!map) return rej(null);

    if (getUserOS() === OS.IOS) {
      setTimeout(() => {
        res(mapRef.current.querySelector("canvas").toDataURL("image/jpeg"));
      }, 1500);
    } else {
      var exportOptions = {
        filter: function (element) {
          return element.className
            ? element.className.indexOf("ol-control") === -1
            : true;
        },
      };

      map.once("rendercomplete", function () {
        toJpeg(map.getTargetElement(), exportOptions).then(function (dataURL) {
          res(dataURL);
        });
      });

      map.renderSync();
    }
  });
};

export default createImageFromMap;
